import { render } from "./EntwicklungsPlan.vue?vue&type=template&id=3c71ca22"
import script from "./EntwicklungsPlan.vue?vue&type=script&lang=ts"
export * from "./EntwicklungsPlan.vue?vue&type=script&lang=ts"

import "./EntwicklungsPlan.vue?vue&type=style&index=0&id=3c71ca22&lang=scss"
script.render = render

export default script